import { render, staticRenderFns } from "./importKaramayEdition.vue?vue&type=template&id=5da53f39&scoped=true&"
import script from "./importKaramayEdition.vue?vue&type=script&lang=js&"
export * from "./importKaramayEdition.vue?vue&type=script&lang=js&"
import style0 from "./importKaramayEdition.vue?vue&type=style&index=0&id=5da53f39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da53f39",
  null
  
)

export default component.exports